import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_PhotoColorizer = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/photo-colorizer',
			name: 'AI Photo Colorizer',
			description:
				'Turn your black-and-white photos into vivid, high-quality color images in seconds. No watermark. Create yours with Lift now.',
			url: 'https://liftapp.ai/photo-colorizer',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/photo-colorizer#product' },
				{ '@id': 'https://liftapp.ai/photo-colorizer#howto' },
				{ '@id': 'https://liftapp.ai/photo-colorizer#benefits' },
				{ '@id': 'https://liftapp.ai/photo-colorizer#faq' },
				{ '@id': 'https://liftapp.ai/photo-colorizer#why-lift' },
				{ '@id': 'https://liftapp.ai/photo-colorizer#explore-tools' },
				{ '@id': 'https://liftapp.ai/photo-colorizer#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/photo-colorizer#product',
			name: 'Old Photo Restoration AI',
			description:
				'Restore old photos to vibrant memories in seconds. Online AI photo restoration tool, no watermarks.',
			url: 'https://liftapp.ai/photo-colorizer',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/photo-colorizer#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Your memories, reborn',
					text: 'Our AI detects every detail — faces, clothes, backgrounds — and brings authentic, balanced color tones that look like real film, not filters',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-colorizer#benefits',
			name: 'Who can benefit from AI Photo Colorizer?',
			description:
				'Lift AI Photo Restoration helps e-commerce sellers, content creators, marketers, and more improve image quality instantly with AI retouching.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Perfect for anyone who wants to preserve and relive their family memories in a realistic way',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Families can restore old black-and-white portraits, adding warmth and nostalgia to photo albums',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Genealogy lovers can bring history to life with stunning colorized archives',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Artists, designers, and creators can use this feature to add emotional depth to old visuals',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Businesses and museums can restore vintage photography with professional quality',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.b7e4220f.webp',
				name: 'Bring Color to Vintage Portraits',
				description:
					'Black and white portrait of a woman with smoke is colorized and enhanced.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/photo-colorizer#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Photo Colorizer?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Colorize Photo is an advanced online tool that brings color back to old or black-and-white photos — making them look as if they were taken yesterday.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Photo Colorizer work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our deep-learning model recognizes people, objects, and lighting, applying realistic color tones that fit the photo’s original mood and time period — automatically, in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will it keep details and faces accurate?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes! Lift preserves skin tones, clothing textures, and even tiny photo details — ensuring your image feels natural, never over-processed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/photo-colorizer#why-lift',
			name: 'Why Lift’s AI Photo Colorizer stands out',
			description:
				"Lift's AI photo restoration provides professional results, AI accuracy, cross-platform support, and is budget-friendly.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyLift.8ae64055.webp',
				name: 'Colorize Historic Landscapes',
				description:
					'Grainy black and white photo of a Moroccan building is brilliantly colorized',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-extender#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/photo-colorizer#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Photo Restoration',
					item: 'https://liftapp.ai/photo-colorizer',
				},
			],
		},
	],
};
